// Dependencies
import { createGlobalStyle } from 'styled-components';

const LayoutStyles = createGlobalStyle`
  :root {
    --color-sand: #eeebea;
    --color-charcoal: #535e6b;
    --color-graphite: #394048;
    --color-walnut: #8d867e;
    --color-bark: #a0988f;
    --color-beige: #e1dddb;
    --color-error: #b53111;
    --color-swiss-coffee: #ddd8d6;
    --color-white: #fff;
    --grid-mobile-gutter: 0.813rem;
    --grid-desktop-gutter: 1.5rem;
    --header-offset-mobile: 5rem;
    --header-offset-desktop: 6.25rem;
    --font-quasimoda: 'Quasimoda';
    --font-weight-light: 200;
    --font-weight-regular: 400;
    --font-weight-medium: 500;
    --font-weight-bold: 700;
    --spacing-none: 0;
    --spacing-small-mobile: 1.5rem;
    --spacing-small-desktop: 3rem;
    --spacing-standard-mobile: 4rem;
    --spacing-standard-desktop: 6rem;
    --spacing-large-mobile: 6rem;
    --spacing-large-desktop: 9rem;
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  ::selection {
    background-color: var(--color-walnut);
    color: #fff;
  }

  html {
    scroll-behavior: smooth;
    background-color: #fff;
  }
  
  .main-wrapper {
    position: relative;
    z-index: 1;
  }

  main {
    margin: var(--header-offset-mobile) 0 0;

    &.front-page {
      margin: 0;
    }

    &.top-spacing {
      padding-top: var(--spacing-standard-mobile);
    }
  }

  section,
  .flexible-content-layout {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  ul,
  ol {
    margin: 0 0 1.5rem 1.1rem;
    padding: 0;

    li::marker {
      color: var(--color-beige);
    }
  }

  .separator {
    position: relative;
    display: block;
    width: 100%;
    height: 0.063rem;
    margin: 0.7rem 0 0;
    background-color: #e1dddb;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: -0.125rem;
      width: 0.25rem;
      height: 0.25rem;
      border-radius: 100%;
      background-color: #e1dddb;
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }

    &.white {
      background-color: #fff;
      opacity 0.5;

      &::before,
      &::after {
        background-color: #fff;
      }
    }
  }

  @media(min-width: 768px) {
    main {
      margin: var(--header-offset-desktop) 0 0;

      &.front-page {
        margin: 0;
      }

      &.top-spacing {
        padding-top: var(--spacing-standard-desktop);
      }
    }

    ul,
    ol {
      margin: 0 0 1.7rem 1.5rem;
    }
  }
`;

export default LayoutStyles;
